// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyVideoDisabledSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.603 19.896a.25.25 0 0 1 0 .354l-.353.353a.25.25 0 0 1-.354 0l-2.216-2.215c-.47.958-1.415 1.612-2.503 1.612H3.824C2.264 20 1 18.657 1 17V7c0-1.188.65-2.215 1.592-2.7L1.325 3.032a.25.25 0 0 1 0-.354l.354-.354a.25.25 0 0 1 .353 0zM17 7v8.67L5.33 4h8.847C15.736 4 17 5.343 17 7zm1.27 3.203 3.333-3.667c.535-.588 1.397-.133 1.397.737V17c0 .824-.784 1.294-1.333.8l-3.334-3A1.079 1.079 0 0 1 18 14v-3.06c0-.28.098-.548.27-.737z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyVideoDisabledSolid;
